import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { INetworkStatus } from '../models/network-status.model';

@Injectable({
  providedIn: 'root'
})
export class NetworkService implements INetworkStatus {
  private status$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private zone: NgZone) {
    const online$ = fromEvent(window, 'online').pipe(map(() => true));
    const offline$ = fromEvent(window, 'offline').pipe(map(() => false));

    merge(online$, offline$, of(navigator.onLine)).subscribe(status => {
      this.zone.run(() => this.status$.next(status));
    });
  }

  get networkStatus$(): Observable<boolean> {
    return this.status$.asObservable();
  }

  get isOnline(): boolean {
    return this.status$.value;
  }
}
